import React, {useEffect, useRef} from 'react';
import {Avatar, Box, Paper, Typography} from '@mui/material';

const MessageList = ({messages, user}) => {
    const messagesEndRef = useRef(null); // Reference to the end of the messages container


    useEffect(() => {
        // Scroll to the bottom whenever messages change
        messagesEndRef.current?.scrollIntoView({behavior: 'smooth'});
    }, [messages]);


    const messageContainerStyle = (isSystemMessage) => ({
        display: 'flex',
        alignItems: 'flex-start',
        flexDirection: isSystemMessage ? 'row-reverse' : 'row', // Position avatar and message based on sender
    });

    const messageStyle = (isSystemMessage) => ({
        padding: '16px',
        backgroundColor: isSystemMessage ? 'rgba(51,51,51,0)' : 'rgba(245,245,245,0.85)',
        borderRadius: '8px',
        color: isSystemMessage ? '#ffffff' : '#333',
        maxWidth: '70%', // Restrict width of message bubble
    });

    const avatarStyle = (isSystemMessage) => ({
        width: 30,
        height: 30,
        margin: isSystemMessage ? '0 8px 0 8px' : '0 0 0 8px', // Adjust margin based on message alignment
    });

    const getAvatar = (message) => {
        return isSystemMessage(message) ? '/hat.webp' : user.photoURL;
    }

    const isSystemMessage = (message) => {
        return message.sender === 'ai';
    }
    return (
        <Box sx={{
            flex: 1,
            backgroundColor: '#ffffff00 !important',
            padding: '16px 32px 16px 32px',
            marginTop: '72px', // Space for the header
            marginBottom: '72px', // Space for the input box
            display: 'flex',
            flexDirection: 'column',
            gap: '16px',
            overflowY: 'auto',
            direction: 'rtl', // Set RTL direction
        }}>
            {messages.map((message, index) => (
                <Box key={index} sx={messageContainerStyle(isSystemMessage(message))}>
                    <Avatar sx={avatarStyle(isSystemMessage(message))} src={getAvatar(message)}/>
                    <Paper elevation={1} sx={messageStyle(isSystemMessage(message))}>
                        <Typography>{message.message}</Typography>
                    </Paper>
                </Box>
            ))}
            <div ref={messagesEndRef}/>
            {/* Ref element to scroll into view */}
        </Box>
    );
};

export default MessageList;
